export function PickAnAttribute(attributes, propertyName) {
  if (attributes == null || attributes[propertyName] == null) {
    return null;
  }
  for (var key in attributes[propertyName]) {
    return attributes[propertyName][key];
  }
}
